// extracted by mini-css-extract-plugin
export default {"descriptionDetails":"DescriptionDetails_descriptionDetails__DNS8Q","compact":"DescriptionDetails_compact__ADQ9d"};